/**
 *
 * @author Matthew Rawson @ 01/06/2018 15:23
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Row} from "react-bootstrap"

import id from "@irati/utils/id"

import {
  Subject,
  BodyHeading,
  BodyText
} from "@irati-web/fields/schedule/preferences/emails/abstract"


class Email extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    property: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }
  static defaultProps = {
    disabled: false
  }


  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const idNamespace = id("Email", this.props)
    const {schedule, property, onChange, disabled} = this.props

    return (
      <React.Fragment>
        <Row>
          <Subject disabled={disabled} id={idNamespace} name={`${property}.subject`} schedule={schedule} onChange={onChange} />
        </Row>
        <Row>
          <BodyHeading disabled={disabled} id={idNamespace} name={`${property}.bodyHeading`} schedule={schedule} onChange={onChange} />
        </Row>
        <Row>
          <BodyText disabled={disabled} id={idNamespace} name={`${property}.bodyText`} schedule={schedule} onChange={onChange} />
        </Row>
      </React.Fragment>
    )
  }
}

export default Email
